import { AxiosRequestConfig } from 'axios';
import axios, { token } from './axios';

const { VITE_API_URL_ROOT } = process.env;

type RequestOptions = Partial<{
  signal: any;
  api: boolean;
  baseURL?: string;
  responseType?: string;
}>;

const request = (method: string, url: string, params: any = {}, options: RequestOptions = {}) => {
  const body = method === 'get' ? 'params' : 'data';
  const { api = true, signal, ...rest } = options;

  const config = {
    method,
    url,
    [body]: params || {},
    baseURL: VITE_API_URL_ROOT,
    ...rest
  } as AxiosRequestConfig;

  if (config.headers === undefined) {
    config.headers = {};
  }

  const { headers } = config;
  const authorize = api
    ? token.getFreshToken().then(() => {
        headers.Authorization = token.getAppToken();
      })
    : Promise.resolve();

  return new Promise((resolve, reject) => {
    authorize
      .then(() =>
        axios.request({
          ...config,
          ...(signal && { signal })
        })
      )
      .then((response) => {
        resolve({ ...response, fromCache: false });
      })
      .catch((error) => reject(error));
  });
};

export default request;
